module.exports = __webpack_public_path__ + "img/fund-home-1.3973e6ca.png";